import React from 'react';
import {
    List, ListItemButton, ListItemText,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FolderIcon from '@mui/icons-material/Folder';
import PersonIcon from '@mui/icons-material/Person';
import StorageIcon from '@mui/icons-material/Storage';
import BuildIcon from '@mui/icons-material/Build';
import PeopleIcon from '@mui/icons-material/People';
import TodayIcon from '@mui/icons-material/Today';
import PublishIcon from '@mui/icons-material/Publish';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import {Link, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useTranslation} from '../../common/components/LocalizationProvider';
import {useAdministrator, useManager, useRestriction} from '../../common/util/permissions';
import useFeatures from '../../common/util/useFeatures';
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";


const MenuItem = ({
                      title, link, icon, selected,
                  }) => (
    <ListItemButton key={link} component={Link} to={link} selected={selected}>
        <ListItemText primary={title}/>
    </ListItemButton>
);

const SettingsMenu = () => {
    const t = useTranslation();
    const location = useLocation();

    const readonly = useRestriction('readonly');
    const admin = useAdministrator();
    const manager = useManager();
    const userId = useSelector((state) => state.session.user.id);

    const features = useFeatures();

    const theme = useTheme();
    const phone = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <List
                sx={phone ?
                    null
                    :
                    {
                        // selected and (selected + hover) states
                        '&& .Mui-selected, && .Mui-selected:hover': {
                            bgcolor: '#414141'
                        },
                        // hover states
                        '& .MuiListItemButton-root:hover': {
                            bgcolor: '#666666'
                        },
                    }
                }
                  style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: 0}}>
                <MenuItem
                    title={t('sharedPreferences')}
                    link="/settings/preferences"
                    icon={<SettingsIcon/>}
                    selected={location.pathname === '/settings/preferences'}
                />
                {!readonly && (
                    <>
                        <MenuItem
                            title={t('sharedNotifications')}
                            link="/settings/notifications"
                            icon={<NotificationsIcon/>}
                            selected={location.pathname.startsWith('/settings/notification')}
                        />
                        <MenuItem
                            title={t('settingsUser')}
                            link={`/settings/user/${userId}`}
                            icon={<PersonIcon/>}
                            selected={location.pathname === `/settings/user/${userId}`}
                        />
                        {!features.disableCalendars && (
                            <MenuItem
                                title={t('sharedCalendars')}
                                link="/settings/calendars"
                                icon={<TodayIcon/>}
                                selected={location.pathname.startsWith('/settings/calendar')}
                            />
                        )}
                    </>
                )}
            </List>
            {manager && (
                <>
                    <List sx={phone ?
                        null
                        :
                        {
                            // selected and (selected + hover) states
                            '&& .Mui-selected, && .Mui-selected:hover': {
                                bgcolor: '#414141'
                            },
                            // hover states
                            '& .MuiListItemButton-root:hover': {
                                bgcolor: '#666666'
                            },
                        }}
                          style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: 0}}>
                        {admin && (
                            <>
                                <MenuItem
                                    title={t('deviceTitle')}
                                    link="/settings/devices"
                                    icon={<SmartphoneIcon/>}
                                    selected={location.pathname === '/settings/device'}
                                />
                                {!features.disableGroups && (
                                    <MenuItem
                                        title={t('settingsGroups')}
                                        link="/settings/groups"
                                        icon={<FolderIcon/>}
                                        selected={location.pathname.startsWith('/settings/group')}
                                    />
                                )}
                                {!features.disableDrivers && (
                                    <MenuItem
                                        title={t('sharedDrivers')}
                                        link="/settings/drivers"
                                        icon={<PersonIcon/>}
                                        selected={location.pathname.startsWith('/settings/driver')}
                                    />
                                )}
                                {!features.disableComputedAttributes && (
                                    <MenuItem
                                        title={t('sharedComputedAttributes')}
                                        link="/settings/attributes"
                                        icon={<StorageIcon/>}
                                        selected={location.pathname.startsWith('/settings/attribute')}
                                    />
                                )}
                                {!features.disableMaintenance && (
                                    <MenuItem
                                        title={t('sharedMaintenance')}
                                        link="/settings/maintenances"
                                        icon={<BuildIcon/>}
                                        selected={location.pathname.startsWith('/settings/maintenance')}
                                    />
                                )}
                                <MenuItem
                                    title={t('sharedSavedCommands')}
                                    link="/settings/commands"
                                    icon={<PublishIcon/>}
                                    selected={location.pathname.startsWith('/settings/command')}
                                />
                                <MenuItem
                                    title={t('settingsServer')}
                                    link="/settings/server"
                                    icon={<StorageIcon/>}
                                    selected={location.pathname === '/settings/server'}
                                />
                            </>
                        )}
                        <MenuItem
                            title={t('settingsUsers')}
                            link="/settings/users"
                            icon={<PeopleIcon/>}
                            selected={location.pathname.startsWith('/settings/user') && location.pathname !== `/settings/user/${userId}`}
                        />
                    </List>
                </>
            )}
        </>
    );
};

export default SettingsMenu;
